module.exports = __webpack_public_path__ + "static/media/call_status_released.42176f5f.svg";